<div class="w-100 h-100">
    <app-pwa-install-prompt></app-pwa-install-prompt>
    <app-update-notification></app-update-notification>
    <app-menu></app-menu>
</div>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>